import React from "react";
import Reveal from "./Reveal";
import { STEPS } from "../mock";

export default function HowItWorks() {
  return (
    <section id="how" style={{ padding: "72px 0" }}>
      <div className="container-x">
        <Reveal>
          <div className="section-label">How it works</div>
          <h2 className="h-section" style={{ marginTop: 18, maxWidth: 720 }}>
            Four steps. <span className="serif" style={{ fontSize: "1.05em" }}>One owner.</span>
          </h2>
          <p style={{ marginTop: 20, fontSize: 17, lineHeight: 1.6, color: "var(--ink-soft)", maxWidth: 560 }}>
            You bring the offer and the target market. We run everything between that and a booked meeting.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-px" style={{ marginTop: 48 }}>
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 80}>
              <div className="card-line" style={{ padding: "32px 30px", height: "100%", borderRadius: 3 }}>
                <div className="flex items-center justify-between">
                  <span className="serif" style={{ fontSize: 44, color: "var(--accent)", lineHeight: 1 }}>{s.n}</span>
                  <span className="eyebrow" style={{ color: "var(--accent-ink)" }}>{s.when}</span>
                </div>
                <h3 style={{ marginTop: 22, fontSize: 22, fontWeight: 600, letterSpacing: "-0.01em" }}>{s.title}</h3>
                <p style={{ marginTop: 12, fontSize: 15, lineHeight: 1.6, color: "var(--ink-soft)" }}>{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
